import api, { unwrap } from './client';

/* Prévisions des ventes (2026-10-10) : la vue calculée, la saisie à l'année,
   la mensualisation (mois tapés, règles, profils) et les lignes de prévision,
   détachées de celles de la Trajectoire. */
export const getOfferMonths = (tenantId, year, span = 1, compare = null) =>
  unwrap(api.get(`/sales-offer-months/${tenantId}/${year}?span=${span}${compare ? `&compare=${compare}` : ''}`));

// Une valeur annuelle d'une ligne : field = actual · backlog · new · total.
export const setForecast = (tenantId, offerId, year, payload) =>
  unwrap(api.put(`/sales-offer-months/${tenantId}/${offerId}/${year}/forecast`, payload));
// Un mois tapé de la mensualisation : flux = bk · new.
export const setForecastMonth = (tenantId, offerId, year, month, payload) =>
  unwrap(api.put(`/sales-offer-months/${tenantId}/${offerId}/${year}/${month}`, payload));
export const resetForecastMonths = (tenantId, offerId, year, payload) =>
  unwrap(api.put(`/sales-offer-months/${tenantId}/${offerId}/${year}/reset`, payload));
// La règle de l'offre (sans flux) ou d'un flux d'une ligne.
export const setForecastRule = (tenantId, offerId, payload) =>
  unwrap(api.put(`/sales-offer-months/${tenantId}/${offerId}/rule`, payload));

export const addForecastLine = (tenantId, offerId, label) =>
  unwrap(api.post(`/sales-offer-months/${tenantId}/${offerId}/lines`, { label }));
export const renameForecastLine = (tenantId, lineId, label) =>
  unwrap(api.patch(`/sales-offer-months/${tenantId}/lines/${lineId}`, { label }));
export const deleteForecastLine = (tenantId, lineId) =>
  unwrap(api.delete(`/sales-offer-months/${tenantId}/lines/${lineId}`));

export const listSeasonProfiles = (tenantId) =>
  unwrap(api.get(`/sales-offer-months/${tenantId}/profiles`));
export const createSeasonProfile = (tenantId, payload) =>
  unwrap(api.post(`/sales-offer-months/${tenantId}/profiles`, payload));
export const updateSeasonProfile = (tenantId, profileId, payload) =>
  unwrap(api.patch(`/sales-offer-months/${tenantId}/profiles/${profileId}`, payload));
// Charge les profils de base qui manquent à la version lue (2026-10-11).
export const loadStandardProfiles = (tenantId) =>
  unwrap(api.post(`/sales-offer-months/${tenantId}/profiles/standard`));
export const deleteSeasonProfile = (tenantId, profileId) =>
  unwrap(api.delete(`/sales-offer-months/${tenantId}/profiles/${profileId}`));

// Les lignes de prévision de chaque offre : { offre: [{ id, label }] } (la section Réalisé y rattache un CA réalisé).
export const listForecastLines = (tenantId) => unwrap(api.get(`/sales-offer-months/${tenantId}/forecast-lines`));

/* Le réalisé mois par mois de chaque offre (CA, facturé, volumes) et une case de ce réalisé (2026-10-22) :
   { offre: { ca, billing, unassigned: { ca, billing }, lines: { ligne: { ca, billing, volume } } } }.
   Une grandeur sans saisie vaut null (n/a). Sans `line_id`, la case est le TOTAL de l'offre ; avec, le détail d'une ligne. */
export const getRealiseGrid = (tenantId, year) => unwrap(api.get(`/sales-offer-months/${tenantId}/${year}/realise`));
export const setRealiseCell = (tenantId, offerId, year, month, payload) =>
  unwrap(api.put(`/sales-offer-months/${tenantId}/${offerId}/${year}/realise/${month}`, payload));
